"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMinDate = formatMinDate;
exports.formatMaxDate = formatMaxDate;
const utils_1 = require("@codegrade/utils");
function formatMinDate(minDate) {
    if (minDate != null) {
        return utils_1.datetime.formatDate(minDate.clone().startOf('minute'));
    }
    else {
        return undefined;
    }
}
function formatMaxDate(maxDate) {
    if (maxDate != null) {
        return utils_1.datetime.formatDate(maxDate.clone().endOf('minute'));
    }
    else {
        return undefined;
    }
}
